import { IMessagingServiceClient } from '../../types/messaging-types';
import { getInstanceRegistryByKey } from '../';

export const getMessagingServiceClient = (): IMessagingServiceClient => {
    const msgsClient: IMessagingServiceClient = getInstanceRegistryByKey('msgsClient', undefined);

    if (msgsClient) {
        return msgsClient;
    }

    throw new Error(
        'msgsClient is not defined. Something might have gone wrong in initialization.'
    );
};
